<!-- <ng-scrollbar class="global-container"  appearance = "compact" #scrollable pointerEventsMethod="scrollbar">    -->
    <div class="dashboard">
        <div class="header m10 mb0">
            <h1 class="m0">{{currentDashboardObj.dashboardName}}</h1>
            <!-- <app-heading [heading]="currentDashboardObj.dashboardName" [editDashboard]="editDashboard" [dashboardtitleFlag]="true" (outputtitle)="ontitleChange($event)"></app-heading>  -->
            <!-- <mat-form-field appearance="fill">
                <mat-select [(ngModel)]="selectedOrganization" (selectionChange)="chooseOrganization($event)" name="momSelect">
                  <ng-container *ngFor="let organization of organizationList">
                    <mat-option [value]="organization.orgCode">
                      {{organization.orgName}}
                    </mat-option>
                </ng-container>
                </mat-select>
              </mat-form-field> -->
          
            <div class="d-flex align-items-center gap-2" *ngIf="!editDashboard">
                <ng-content select="[content]"></ng-content>
                <!-- <div class="divider"></div>
                <span class="material-symbols-outlined cursor-pointer" title="Show Filter" (click)="showFilter = !showFilter" >filter_alt</span> -->
                <!-- <div class="divider"></div> -->
                <span class="material-symbols-outlined cursor-pointer" title="Edit Dashboard" (click)="showHideDashboardBGConfig(true,'')">edit</span>
                <span class="material-symbols-outlined cursor-pointer" title="Delete Dashboard" (click)="layout = []">delete</span>
           </div>
    
            <div class="d-flex align-items-center gap-2" *ngIf="editDashboard">
                <div class=" d-flex gap-2" > 
                    <!-- <span class="material-symbols-outlined cursor-pointer" title="Add Report(s)" >add</span> -->
                    <div class="report-menu" *ngIf="showReportMenu">
                        <div class="toggle-icon" (click)="showReportMenu = false">
                            <span class="material-symbols-outlined">arrow_circle_right</span>
                        </div>
                        <div class="srh">     
                             <mat-form-field appearance="fill">
                            <!-- <mat-label>MOM</mat-label> -->
                            <mat-select [(ngModel)]="selectedOrganization" (selectionChange)="chooseOrganization($event)" name="momSelect">
                              <ng-container *ngFor="let organization of organizationList">
                                <mat-option [value]="organization.orgCode">
                                  {{organization.orgName}}
                                </mat-option>
                            </ng-container>
                            </mat-select>
                          </mat-form-field>
                            <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" class="" />
                            <span _ngcontent-ng-c211801908="" class="material-symbols-outlined position-absolute r15">search</span>
                        </div>
                        <div class="breadcrumbs-container mt10 ml2">
                            <div class="section-title cursor-pointer" [ngClass]="{'link' : selectedCategory}" (click)="backToCategories()">Available Reports</div>
                            <span *ngIf="selectedCategory"> > {{ selectedCategory | uppercase }}</span>
                        </div>
                        <div *ngIf="!selectedCategory">
                        <ul class="report-list">
                            <li *ngFor="let category of groupedKeys" (click)="selectCategory(category)" class="category-item">
                            <span class="material-symbols-outlined cursor-pointer">folder</span> {{ category | uppercase}}
                            </li>
                        </ul>
                        </div>
                        
                        <div *ngIf="selectedCategory">
                        <!-- <span class="material-symbols-outlined cursor-pointer" 
                                (click)="backToCategories()" 
                                title="Back to category">arrow_circle_left</span>  -->
                        <ul class="report-list">
                            <li *ngFor="let report of filteredReports()" 
                                (click)="addReport(report.reportID, report.reportType)" 
                                class="report-item">
                            <span *ngIf="report.reportType === 'chart'" class="material-symbols-outlined">bar_chart</span>
                            <span *ngIf="report.reportType !== 'chart'" class="material-symbols-outlined">lab_profile</span>
                            {{ report.reportName }}
                            </li>
                            <li *ngIf="filteredReports().length === 0">
                            <small class="no-reports">No Reports Found</small>
                            </li>
                        </ul>
                        </div>
                        
                        <!-- <ng-template #noCategories>
                        <p>No categories available.</p>
                        </ng-template>
                        
                        <div *ngIf="selectedCategory">
                            <ul class="report-list">
                                <li *ngFor="let report of filteredReports()" 
                                    (click)="addReport(report.reportID, report.reportType)" 
                                    class="report-item">
                                <span *ngIf="report.reportType === 'chart'" class="material-symbols-outlined">bar_chart</span>
                                <span *ngIf="report.reportType !== 'chart'" class="material-symbols-outlined">lab_profile</span>
                                {{ report.reportName }}
                                </li>
                                <li *ngIf="filteredReports().length === 0">
                                <small class="no-reports">No Reports Found</small>
                                </li>
                            </ul>
                        </div> -->
                        
                        <ng-template #noCategories>
                        <p>No categories available.</p>
                        </ng-template>
                    </div>
                </div>
                <div class="adc-dropdown" #dropdown3>
                    <span class="material-symbols-outlined cursor-pointer" title="Add a Heading or text" (click)="toggleDropdown('selected')" >add</span>
                    <div class="adc-dropdown-option-menu mt5" appendTo="body" *ngIf="addOptions()">
                      <ng-container *ngFor="let item of ['card','Upcoming Meeting','Chart']">
                          <a class="dropdown-options" (click)="addLayout(item)">{{item}}</a>
                      </ng-container>
                    </div>
                </div>
                <div *ngIf="showTableOptions">
                    <ul class="report-menu">
                        <li *ngFor="let table of tableList" 
                                (click)="addTable(table)"
                                class="category-item">
                            <span class="material-symbols-outlined">table_chart</span>
                            {{ table.label }}
                        </li>
                        <li *ngIf="tableList.length === 0">
                            <small class="no-reports">No Reports Found</small>
                        </li>
                    </ul>
                </div>
                <div *ngIf="showCardOptions">
                    <ul class="report-menu">
                        <li *ngFor="let card of cardList" 
                                (click)="addCard(card)"
                                class="category-item">
                            <span class="material-symbols-outlined">table_chart</span>
                            {{ card.label }}
                        </li>
                        <li *ngIf="tableList.length === 0">
                            <small class="no-reports">No Reports Found</small>
                        </li>
                    </ul>
                </div>
    
                <!-- <span class="material-symbols-outlined" title="Select All" (click)="selectAll()">library_add_check</span>
                <span class="material-symbols-outlined" title="Clear All" (click)="clearSelectedValues()">remove_selection</span> -->
                <div class="adc-dropdown" #dropdown2>
                    <!-- <span class="material-symbols-outlined cursor-pointer" title="Add a Heading or text" (click)="toggleDropdown('addTextArea')" >text_fields</span> -->
                    <div class="dropdown-option-menu mt5" appendTo="body" *ngIf="addDropdown">
                    <a class="adc-dropdown-options" (click)="addheader();">Header</a>
                    <a class="dropdown-options" (click)="addDescription()">Description</a>
                    </div>
                </div>
                <!-- <span class="material-symbols-outlined cursor-pointer" title="Add Section">auto_awesome_mosaic</span> -->
                <button height="20px" class="btn btn-sm btn-outline-primary" (click)="showHideDashboardBGConfig(false,'')">Cancel</button>
                <button height="20px" class="btn btn-sm btn-primary" (click)="showHideDashboardBGConfig(false,'save')">Save</button>
            </div>
        </div>

        <div class="dashboard-action">

            <div class="adc-d-flex adc-gap-2 adc-align-items-center">
                <!-- <div class="adc-d-flex" > -->
                    <div>
                        <img width="60" height="60" src="../../../assets/icons/user-img.jpg" alt="">
                    </div>
                    <div>
                        <b class="username">Welcome Administrator!</b>
                        <div>"The secret of getting ahead is getting started"</div>
                        <span class="d-flex gap-2"><span class="material-symbols-outlined">
                            calendar_month
                            </span>{{getLiveDate()}}</span>
                    </div>
                   <!-- <p [ngStyle]="{'color':'white', 'margin-top':'20%'}">
                     We're glad to see you again. Let's get started.
                   </p>                         -->
                   <!-- <p>{{getLiveDate()}}</p> -->
                 <!-- </div> -->
            </div>
             <div class="org-name">
                <h3 [ngStyle]="{'color':'var(--adc-primary-theme)'}">organization Name:</h3>      
                 <!-- <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="selectedOrganization" (selectionChange)="chooseOrganization($event)" name="momSelect">
                      <ng-container *ngFor="let organization of organizationList">
                        <mat-option [value]="organization.orgCode">
                          {{organization.orgName}}
                        </mat-option>
                    </ng-container>
                    </mat-select>
                  </mat-form-field> -->
                  <div class="org-dropdown">
                    <div class="adc-d-flex adc-align-items-center adc-gap-2 adc-justify-content-between" (click)="orgdropdown.set(!orgdropdown())">
                        <div>{{selectedOrganization?.orgName}}</div>
                        <span class="material-symbols-outlined" [class.active]="orgdropdown()">keyboard_arrow_down</span>                        
                    </div>
                    <div class="org-droplist"  [ngStyle]="{'display':orgdropdown() ? 'block': 'none'}">
                        @for(item of organizationList; track $index) {
                            <div class="org-dropitem" [class.org-acitve]="item.orgName === selectedOrganization?.orgName" (click)="chooseOrganization(item)">{{item.orgName}}</div>
                        }
                    </div>
                  </div>
             </div>
             <!-- <div  class="meeting-category">
            @for (item of btnAction; track $index) {
                    <button class="btn-primary" (click)="btnActivate(item)" [ngClass]="btnActive === item ? 'btn-active' : 'btn-disable' ">
                         <span>{{item}}</span>
                    </button>
                } 
             </div> -->
        </div>
        <div class="p10" *ngIf="showFilter">
            <app-filter [defaultFilters]="defaultFilters"></app-filter>
        </div>

        <!-- <div>
            <div class="meeting-card" [ngStyle]="{'background':'#3f51b5','text-align':'center','width':400 + 'px','margin-top':39+'px','height':200+'px'}">
                <b [ngStyle]="{'color':'white'}">Hi Administrator!!</b>
               <p [ngStyle]="{'color':'white', 'margin-top':'20%'}">
                 We're glad to see you again. Let's get started.
               </p>                        
             </div>
        </div> -->
        <!-- <dashboard-filter [editDashboard]="editDashboard" [showFilter]="showFilter" [dropdownData]="dropdownData" ></dashboard-filter> -->
        <!-- <ng-scrollbar class="global-container"  appearance = "compact" #scrollable pointerEventsMethod="scrollbar">    -->
      <div #parentScrollgrid class="parent">
        <ktd-grid [cols]="cols" [backgroundConfig]="gridBackgroundConfig" [layout]="layout"
        [rowHeight]="rowHeightFit ? 'fit' : rowHeight" [gap]="gap" [scrollSpeed]="2" 
        [scrollableParent]="parentScrollgrid"
        (layoutUpdated)="onLayoutUpdated($event)" #gridComp>
        <ktd-grid-item *ngFor="let item of layout; let i=index" [id]="item.id" [class.ktd-border]="editDashboard" [style.cursor]="!disableDrag ? 'grab' : ''"
            [transition]="currentTransition" [dragStartThreshold]="dragStartThreshold" [draggable]="!disableDrag"
            [resizable]="!disableResize" (ktdGridBackground)="backgroundConfig">

            <ng-container [ngSwitch]="item.type">
                <ng-container *ngSwitchCase="'table'">
                    <div class="panel panel-style1 rounded grid-item-content m10">
                        <app-table [dataSource]="item.data" [noData]="false"></app-table>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'chips'">
                    <div #panel class="panel panel-style1 overflow-hidden rounded grid-item-content m10 d-flex flex-wrap">
                            <!-- <div class="card card-small card-align-center m6" id="i.id" 
                            [ngClass]="i.color == 'green' ? 'bg-green cl-white' : 'bg-maroon cl-white'">
                                <h3 class="m0 cl-white">{{i.label}}</h3>                                   
                                <h2 class="m0 cl-white">{{i.count}}</h2>
                            </div> -->               
                              


                            <div class="chip-card">
                                <app-chip [containerHeight]="panel.clientHeight" *ngIf="item.data=='meeting' && reload" [orgcode]="selectedOrganization.orgCode"  [type]="'meeting'"></app-chip>
                                <app-chip [containerHeight]="panel.clientHeight" *ngIf="item.data=='task' && reload" [orgcode]="selectedOrganization.orgCode" [type]="'task'"></app-chip>
                            </div>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'meetingChips'">
                    <div class="panel panel-style1 rounded grid-item-content m10 d-flex flex-wrap">
                            <!-- <div class="card card-small card-align-center m6" id="i.id" 
                            [ngClass]="i.color == 'green' ? 'bg-green cl-white' : 'bg-maroon cl-white'">
                                <h3 class="m0 cl-white">{{i.label}}</h3>                                   
                                <h2 class="m0 cl-white">{{i.count}}</h2>
                            </div> -->
                            <div class="chip-card">
                                <app-chip *ngIf="item.data=='meeting' && reload" [orgcode]="selectedOrganization"  [type]="'meeting'"></app-chip>
                                <app-chip *ngIf="item.data=='task' && reload" [orgcode]="selectedOrganization" [type]="'task'"></app-chip>
                            </div>
                    </div>
                </ng-container>

                <ng-container *ngSwitchCase="'taskChips'">
                    <div class="panel panel-style1 rounded grid-item-content m10 d-flex flex-wrap">
                            <!-- <div class="card card-small card-align-center m6" id="i.id" 
                            [ngClass]="i.color == 'green' ? 'bg-green cl-white' : 'bg-maroon cl-white'">
                                <h3 class="m0 cl-white">{{i.label}}</h3>                                   
                                <h2 class="m0 cl-white">{{i.count}}</h2>
                            </div> -->
                            <div class="chip-card">
                                <app-chip *ngIf="item.data=='meeting' && reload" [orgcode]="selectedOrganization"  [type]="'meeting'"></app-chip>
                                <app-chip *ngIf="item.data=='task' && reload" [orgcode]="selectedOrganization" [type]="'task'"></app-chip>
                            </div>
                    </div>
                </ng-container>

                <!--Cards-->

                <ng-container *ngSwitchCase="'meeting'">
                    <div class="panel panel-style1 overflow-auto" [@listAnimation]="item.data">
                     <div class="d-flex">
                        <div class="meeting-card" [ngStyle]="{'background':'#3f51b5','text-align':'center','width':400 + 'px','margin-top':39+'px','height':200+'px'}">
                           <b [ngStyle]="{'color':'white'}">Hi Administrator!!</b>
                          <p [ngStyle]="{'color':'white', 'margin-top':'20%'}">
                            We're glad to see you again. Let's get started.
                          </p>                          <div class="meeting-card" [ngStyle]="{'background':'#3f51b5','text-align':'center','width':400 + 'px','margin-top':39+'px','height':200+'px'}">
                           <b [ngStyle]="{'color':'white'}">Hi Administrator!!</b>
                          <p [ngStyle]="{'color':'white', 'margin-top':'20%'}">
                            We're glad to see you again. Let's get started.
                          </p>                        
                        </div>
                        </div>
                        @for (card of item.data; track $index;let i = $index) {
                            <div class="meeting-card" (click)="getMeetingDetail(card,i)" [ngStyle]="{'border-color':getCardBorder(card.label)}">
                                <h2>{{card.label}}</h2>

                                <div class="d-flex justify-content-between adc-pt-12" [ngStyle]="{'top':'43px', 'border-bottom':'0.5px solid #ccc'}">
                                    @for (day of card.data; track $index;let c = $index) {
                                            <span class="cursor-pointer" [style.border-bottom]="day.active  ? '1px solid darkcyan' : ''" [ngClass]="day.active? 'activeDay' : 'disableDay'" (click)="setActiveData(card?.data,c);$event.stopPropagation()" >{{day.name}}</span>
                                         }
                                     </div>

                                <div class="count">
                                    @for (meetingData of card.data; track $index;let y = $index) {
                                    <div class="d-grid gap-2" *ngIf="meetingData.active">
                                        <span>Total</span>
                                        <span >{{meetingData.total}}</span>
                                    </div>
                                    <div class="d-grid gap-2" *ngIf="meetingData.active">
                                        <span>Hours</span>
                                        <span>{{meetingData.hours}}</span>
                                    </div>
                                }
                                </div>

                                <!-- <img class="card-img" width="24" height="24" src="assets/icons/{{card.img}}.svg" alt=""> -->
                                <!-- <div class="d-flex gap-3 position-absolute" [ngStyle]="{'bottom':'12px'}">
                               @for (item of card.data; track $index) {
                                       <span [ngClass]="activeday === item.name ? 'activeDay' : 'disableDay'" (click)="setActiveData(item.name)" >{{item.name}}</span>
                                    }
                                </div> -->
                        </div>
                        }
                     </div>
                    </div>
                </ng-container>
                <!-- <ng-container *ngSwitchCase="'meeting'">
                    <div class="panel panel-style1 rounded">
                        <div class="meeting-card">
                              @for (card of item.data.data; track $index) {
                                      <b>{{card.label}}</b>
                                      <div class="d-flex justify-content-betweeen">
                                          <div class="d-grid gap-2">
                                              <span>Total</span>
                                              <span>{{card.total}}</span>
                                          </div>
                                          <div class="d-grid gap-2">
                                              <span>Hours</span>
                                              <span>{{card.hours}}</span>
                                          </div>
                                      </div>
                                  
                              }
                              @for (data of item.data.data; track $index) {
                              <div class="d-flex justify-content-betweeen" [ngStyle]="{'color': activeday === data.name ? 'blue' : 'black'}" (click)="setActiveData(data)">{{data.name}}</div>
                              }
                          
                        </div>
                      </div>
                </ng-container> -->

               <ng-container *ngSwitchCase="'upcomingMeeting'">
                <div class="panel panel-style1 overflow-auto">
                    <div class="adc-pad-15">
                        <div class="meeting-title">
                            <b>UpComing Meeting</b>
                        </div>
                     <div class="adc-pad-15 "> 
                        @for(meeting of upcomingMeeting;track meeting;let last = $last){
                            <div class="upcoming-meeting">
                             <div class="position-relative d-flex adc-top-9">
                               <div class="line-section">
                                 <!-- <span class="ball"></span> -->
                                 <span *ngIf="!last" class="line"></span>
                               </div>
 
                                 <div class="adc-pl-25 justify-content-between position-relative adc-top--10">
                                       <div>
                                         <b class="adc-pb-3">{{meeting.name}}</b>
                                       <div class="d-flex adc-gap-1 align-items-center font-weight-500">Createdby:<span >{{meeting.createdBy}}</span></div>
                                       </div>
                                       <div class="font-weight-500">
                                         Time Remaining:<span>{{meeting?.timeRemaining}}</span>
                                       </div>
                                 </div>
                             </div>
 
                            </div>
                         }
                     </div>

                    </div>
                </div>
               </ng-container>

               <ng-container *ngSwitchCase="'chart'">
                <div class="panel panel-style1">
                    <h3 class="chart-title">{{item.data?.label}}</h3>
                    <div echarts [options]="item.data" (chartClick)="onChartClick($event,item.data.type)" class="demo-chart"></div>
                </div>
               </ng-container>

                <div *ngSwitchCase="'meetingPortlet'" class="panel panel-style1 rounded grid-item-content m10">
                    <button (click)="toggleComponent()">slide</button>
                    <app-upcoming-meeting *ngIf="currentComponent == 'upcoming'" [meetingCount]="meetingCount" [deviceXs] = "deviceXs" [deviceSm] = "deviceSm" [deviceMd] = "deviceMd" [deviceLg] = "deviceLg" [deviceXl] = "deviceXl"></app-upcoming-meeting>
                    <app-past-meetings *ngIf="currentComponent == 'past'"   [deviceXs] = "deviceXs" [deviceSm] = "deviceSm" [deviceMd] = "deviceMd" [deviceLg] = "deviceLg" [deviceXl] = "deviceXl"></app-past-meetings>
                    <app-document-meeting *ngIf="meetingCount>0 && currentComponent == 'document'"  [deviceXs] = "deviceXs" [deviceSm] = "deviceSm" [deviceMd] = "deviceMd" [deviceLg] = "deviceLg" [deviceXl] = "deviceXl"></app-document-meeting>
                </div>
                
                <div *ngSwitchCase="'heading'" class="panel panel-style1 rounded grid-item-content m10"
                    (mouseover)="showIconsSet.add(item.id)" (mouseleave)="showIconsSet.delete(item.id)">
                    <div class="d-flex align-items-center gap-2 justify-content-end p3 cursor-pointer icons"
                        *ngIf="!editDashboard && showIconsSet.has(item.id)">
                        <div class="adc-dropdown" appClickOutside (clickOutside)="openMenuId = null">
                            <svg xmlns="http://www.w3.org/2000/svg" id="Glyph" enable-background="new 0 0 32 32"
                                height="14px" viewBox="0 0 32 32" width="14px" (click)="toggleMenu(item.id)">
                                <path id="XMLID_294_" d="m13 16c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                                <path id="XMLID_295_" d="m13 26c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                                <path id="XMLID_297_" d="m13 6c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                            </svg>
                            <div class="adc-dropdown-option-menu" appendTo="body" *ngIf="isMenuVisible(item.id)">
                                <a class="dropdown-options" *ngFor="let i of paneOpts">{{ i.label }}</a>
                            </div>
                        </div>
                    </div>
                    <!-- <app-heading [heading]="item.content" [editDashboard]="editDashboard"
                        (outputHeader)="onHeadingChange(item.id,$event)"></app-heading> -->
                </div>
                <!-- <div *ngSwitchCase="'heading'" [ngClass]="editDashboard ? 'panel panel-style1 rounded ' : ''" class="grid-item-content m10" >
                        <app-heading-comp [heading]="item.content" [editDashboard]="editDashboard"></app-heading-comp>
                    </div> -->

                <div *ngSwitchCase="'text'" class="panel panel-style1 rounded grid-item-content m10"
                    (mouseover)="showIconsSet.add(item.id)" (mouseleave)="showIconsSet.delete(item.id)">
                    <!-- <div class="iptgrp-top ml10 mr20 w-95">
                            <textarea id="description"><p>{{ item.content }}</p></textarea>
                        </div> -->
                    <div class="d-flex justify-content-between">
                        <!-- <h4 class="m0 mb5 mt15 ml15" *ngIf="item.title">{{item.title}}</h4> -->
                        <div class="d-flex align-items-center gap-2 justify-content-end p3 cursor-pointer icons"
                            *ngIf="!editDashboard && showIconsSet.has(item.id)">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" height="14px" width="14px" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 384.97 384.97" [ngStyle]="{'enable-background':'new 0 0 384.97 384.97', 'margin-top':'-3px'}" xml:space="preserve">
                                    <g>
                                        <g id="Fullscreen">
                                            <path d="M384.97,12.03c0-6.713-5.317-12.03-12.03-12.03H264.847c-6.833,0-11.922,5.39-11.934,12.223    c0,6.821,5.101,11.838,11.934,11.838h96.062l-0.193,96.519c0,6.833,5.197,12.03,12.03,12.03c6.833-0.012,12.03-5.197,12.03-12.03    l0.193-108.369c0-0.036-0.012-0.06-0.012-0.084C384.958,12.09,384.97,12.066,384.97,12.03z"/>
                                            <path d="M120.496,0H12.403c-0.036,0-0.06,0.012-0.096,0.012C12.283,0.012,12.247,0,12.223,0C5.51,0,0.192,5.317,0.192,12.03    L0,120.399c0,6.833,5.39,11.934,12.223,11.934c6.821,0,11.838-5.101,11.838-11.934l0.192-96.339h96.242    c6.833,0,12.03-5.197,12.03-12.03C132.514,5.197,127.317,0,120.496,0z"/>
                                            <path d="M120.123,360.909H24.061v-96.242c0-6.833-5.197-12.03-12.03-12.03S0,257.833,0,264.667v108.092    c0,0.036,0.012,0.06,0.012,0.084c0,0.036-0.012,0.06-0.012,0.096c0,6.713,5.317,12.03,12.03,12.03h108.092    c6.833,0,11.922-5.39,11.934-12.223C132.057,365.926,126.956,360.909,120.123,360.909z"/>
                                            <path d="M372.747,252.913c-6.833,0-11.85,5.101-11.838,11.934v96.062h-96.242c-6.833,0-12.03,5.197-12.03,12.03    s5.197,12.03,12.03,12.03h108.092c0.036,0,0.06-0.012,0.084-0.012c0.036-0.012,0.06,0.012,0.096,0.012    c6.713,0,12.03-5.317,12.03-12.03V264.847C384.97,258.014,379.58,252.913,372.747,252.913z"/>
                                        </g>
                                    </g>
                                </svg> -->
                            <div class="adc-dropdown" appClickOutside (clickOutside)="openMenuId = null">
                                <svg xmlns="http://www.w3.org/2000/svg" id="Glyph" enable-background="new 0 0 32 32"
                                    height="14px" viewBox="0 0 32 32" width="14px" (click)="toggleMenu(item.id)">
                                    <path id="XMLID_294_"
                                        d="m13 16c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                                    <path id="XMLID_295_"
                                        d="m13 26c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                                    <path id="XMLID_297_"
                                        d="m13 6c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                                </svg>
                                <div class="adc-dropdown-option-menu" appendTo="body" *ngIf="isMenuVisible(item.id)">
                                    <a class="dropdown-options" *ngFor="let i of paneOpts">{{ i.label }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <app-description [description]="item.content" [title]="item.title" [editDashboard]="editDashboard"
                        (outputDescription)="onDescriptionChange(item.id,$event)"></app-description>
                </div>

                <div class="col-md-12" *ngSwitchCase="'Annoucement'">
                    <app-text-display joyrideStep="dashboardFifthStep" [deviceXs] = "deviceXs" [deviceSm] = "deviceSm" [deviceMd] = "deviceMd" [deviceLg] = "deviceLg" [deviceXl] = "deviceXl"></app-text-display>
                </div>

                <div *ngSwitchDefault class="panel panel-style1 rounded grid-item-content m10"
                    (mouseover)="showIconsSet.add(item.id)" (mouseleave)="showIconsSet.delete(item.id)">

                    <!-- <div class="panel-heading">
                            <div class="d-flex align-items-center">
                                <div class="mr10 d-flex" [ngStyle]="{'color':'#ffffff'}" contenteditable="true">
                                {{item.title}} 
                                </div>
                            </div>
                            <div class="d-flex align-items-center gap-2" [ngStyle]="{'float':'right'}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" fill="white" viewBox="0 0 24 24"><title>eye</title><path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" /></svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" fill="white" viewBox="0 0 24 24"><title>window-maximize</title><path d="M4,4H20V20H4V4M6,8V18H18V8H6Z" /></svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" fill="white" viewBox="0 0 24 24"><title>image-area</title><path d="M20,5A2,2 0 0,1 22,7V17A2,2 0 0,1 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M5,16H19L14.5,10L11,14.5L8.5,11.5L5,16Z" /></svg>
                            </div>
                        </div>  -->
                    <div class="d-flex align-items-center gap-2 justify-content-end p3 cursor-pointer icons"
                        *ngIf="!editDashboard && showIconsSet.has(item.id)">
                        <!-- <svg xmlns="http://www.w3.org/2000/svg" height="20px" width="16px" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 384.97 384.97" [ngStyle]="{'enable-background':'new 0 0 384.97 384.97', 'margin-top':'-3px'}" xml:space="preserve">
                                <g>
                                    <g id="Fullscreen">
                                        <path d="M384.97,12.03c0-6.713-5.317-12.03-12.03-12.03H264.847c-6.833,0-11.922,5.39-11.934,12.223    c0,6.821,5.101,11.838,11.934,11.838h96.062l-0.193,96.519c0,6.833,5.197,12.03,12.03,12.03c6.833-0.012,12.03-5.197,12.03-12.03    l0.193-108.369c0-0.036-0.012-0.06-0.012-0.084C384.958,12.09,384.97,12.066,384.97,12.03z"/>
                                        <path d="M120.496,0H12.403c-0.036,0-0.06,0.012-0.096,0.012C12.283,0.012,12.247,0,12.223,0C5.51,0,0.192,5.317,0.192,12.03    L0,120.399c0,6.833,5.39,11.934,12.223,11.934c6.821,0,11.838-5.101,11.838-11.934l0.192-96.339h96.242    c6.833,0,12.03-5.197,12.03-12.03C132.514,5.197,127.317,0,120.496,0z"/>
                                        <path d="M120.123,360.909H24.061v-96.242c0-6.833-5.197-12.03-12.03-12.03S0,257.833,0,264.667v108.092    c0,0.036,0.012,0.06,0.012,0.084c0,0.036-0.012,0.06-0.012,0.096c0,6.713,5.317,12.03,12.03,12.03h108.092    c6.833,0,11.922-5.39,11.934-12.223C132.057,365.926,126.956,360.909,120.123,360.909z"/>
                                        <path d="M372.747,252.913c-6.833,0-11.85,5.101-11.838,11.934v96.062h-96.242c-6.833,0-12.03,5.197-12.03,12.03    s5.197,12.03,12.03,12.03h108.092c0.036,0,0.06-0.012,0.084-0.012c0.036-0.012,0.06,0.012,0.096,0.012    c6.713,0,12.03-5.317,12.03-12.03V264.847C384.97,258.014,379.58,252.913,372.747,252.913z"/>
                                    </g>
                                </g>
                            </svg > -->
                        <!-- <span class="material-symbols-outlined iclr" title="window-maximize"
                            (click)="chartToShow = item; chartPopup = true;">fullscreen</span> -->

                        <div class="adc-dropdown" appClickOutside (clickOutside)="openMenuId = null">
                            <svg xmlns="http://www.w3.org/2000/svg" id="Glyph" enable-background="new 0 0 32 32"
                                height="14px" viewBox="0 0 32 32" width="14px" (click)="toggleMenu(item.id)">
                                <path id="XMLID_294_" d="m13 16c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                                <path id="XMLID_295_" d="m13 26c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                                <path id="XMLID_297_" d="m13 6c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3z" />
                            </svg>
                            <div class="adc-dropdown-option-menu" appendTo="body" *ngIf="isMenuVisible(item.id)">
                                <a class="dropdown-options" *ngFor="let i of paneOpts">{{ i.label }}</a>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="panel-body"> -->
                    <div class="loader"></div>
                    <div class="panel-content">
                        @if (item.reportid == null) {
                        <div class="portlet-container">
                            <!-- <button height="20px" class="btn btn-sm btn-outline-primary centered-button">Select
                                Report</button> -->
                        </div>
                        }
                        <div class="chart-title">Last 6 Months Meeting Types</div>
                        <div>
                            <div echarts [options]="item.data" (chartClick)="onChartClick($event,item.data.type)" class="chart"></div>
                        </div>

                        <!-- <pheme-viz [reportData]="reportData" [vizType]="vizType" [vizOptions]="vizOptions"></pheme-viz> -->
                    </div>
                    <!-- </div> -->
                </div>

            </ng-container>

            <div class="grid-item-remove-handle" [style.filter]="item.type !== 'chart' ? 'brightness(0) invert(1)': ''" *ngIf="!disableRemove" (mousedown)="stopEventPropagation($event)"
                (click)="removeItem(item.id)">
            </div>
            <ng-template *ngIf="currentPlaceholder !== 'Default'" ktdGridItemPlaceholder>
                <div *ngIf="currentPlaceholder === 'Custom 1'"
                    class="grid-item-content custom-placeholder custom-placeholder-1"></div>
                <div *ngIf="currentPlaceholder === 'Custom 2'"
                    class="grid-item-content custom-placeholder custom-placeholder-2"></div>
                <div *ngIf="currentPlaceholder === 'Custom 3'"
                    class="grid-item-content custom-placeholder custom-placeholder-3"></div>
            </ng-template>

        </ktd-grid-item>

    </ktd-grid>
      </div>
        <!-- </ng-scrollbar> -->
    </div>
<!-- </ng-scrollbar> -->

